export default __webpack_public_path__ + "static/media/vetting-eye.e8656dd7.svg";